module.exports = __webpack_public_path__ + "img/esx-blog.b2fce9b1.jpg";